<template>
  <main
    class="login-main-section"
    :style="{
      backgroundImage:
        'url(https://cdn.trailfinders.com/6stsf6avyp_map3.jpg)',
    }"
  >
  <div class="grad">
    <section class="login-home-page">
      <b-container>
        <slot />
      </b-container>
    </section>
    </div>
    <LoadingSpinner />
  </main>
</template>

<script>
import LoadingSpinner from "@/partials/spinner";
export default {
  components: {
    LoadingSpinner,
  },
};
</script>

<style scoped>
@import "./styles.scss";
</style>
